import { render } from "./Restriction.vue?vue&type=template&id=3928adce"
import script from "./Restriction.vue?vue&type=script&lang=js"
export * from "./Restriction.vue?vue&type=script&lang=js"

import "./Restriction.vue?vue&type=style&index=0&id=3928adce&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__